import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { OrganizationInvitation } from '../../models/organization.model';
import { environment } from '../../../environments/environment';
import { ApiService } from '../http/api.service';

@Injectable({
  providedIn: 'root'
})
export class InvitesService {

  private userInvitations = new BehaviorSubject<OrganizationInvitation[]>([]);
  userInvitations$ = this.userInvitations.asObservable();

  constructor(private api: ApiService) {
    this.getMyInvitations();
  }

  getMyInvitations(): Observable<OrganizationInvitation[]> {
    return this.api.get<OrganizationInvitation[]>(`users/invites`).pipe(
      tap(invitations => this.userInvitations.next(invitations))
    );
  }

  acceptInvitation(invitationId: string): Observable<void> {
    return this.api.post<void>(`users/${invitationId}/verify-email`, {
      inviteId: invitationId
    });
  }

  rejectInvitation(invitationId: string): Observable<void> {
    return this.api.post<void>(`users/${invitationId}/reject`, {
      inviteId: invitationId
    });
  }

  reset(): void {
    this.userInvitations.next([]);
  }
  
} 